import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"

@Injectable({
    providedIn: 'root'
})
export class DataSynchronizerService {

    private _data = new BehaviorSubject<any>(null)
    currentData = this._data.asObservable()

    next(table: 'documents' | 'clients' | 'products' | 'activityLogs' | 'ksefInvoices' | 'notifications' | string, value, syncAt) {
        this._data.next({
            table: table,
            value: value,
            syncAt: syncAt
        })
    }

    received() {
        this._data.next(null)
    }
}